import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const AccordianPDPStyles = css<{ theme: StyledTheme }>`
  .accordian-container {
    position: relative;
    background-color: #d3dcef;
    padding: ${({ theme }) => theme.sizing.paddingS}rem;
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: auto;

    .radio-label {
      margin-top: 0rem;
      margin-bottom: 1rem;

      .radio-input-label {
        margin-top: 0.125rem;
        font-family: ${({ theme }) => theme.typography.mainFontFamilyMedium};
      }
    }

    .accordian-content-inactive .radio-label {
      margin-top: 1.5rem;
      margin-bottom: 0rem;
    }
  }

  .accordian-header {
    margin: 0px;
    text-align: center;
    font-size: ${({ theme }) => theme.sizing.fontM}rem;
    color: ${({ theme }) => theme.palette.primary.color};
    font-family: ${({ theme }) => theme.typography.contentFontFamily};
    padding-bottom: 0.4rem;
  }

  .accordian-content-active {
    position: relative;
    background-color: #f2f5fa;
    padding: ${({ theme }) => theme.sizing.paddingS}rem;
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem;
    margin: 0 0 ${({ theme }) => theme.sizing.marginS}rem 0;
    height: 95%;
  }

  .accordian-content-hidden {
    padding: 0 0 0 ${({ theme }) => theme.sizing.paddingS}rem;
  }

  .accordian-btn {
    width: 90%;
    height: 3rem;
    margin: 0.4rem auto;
    border: none;
    background-color: ${({ theme }) => theme.palette.primaryButton.color};
    color: ${({ theme }) => theme.palette.primaryBackground.color};
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.typography.contentFontFamily};
    transition: 0.2s ease-in-out;
  }

  .accordian-btn-hbp {
    width: 90%;
    height: 3rem;
    margin: 0.4rem auto;
    border: none;
    background-color: ${({ theme }) => theme.palette.primaryButton.color};
    color: ${({ theme }) => theme.palette.primaryBackground.color};
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.typography.contentFontFamily};
    transition: 0.2s ease-in-out;
  }

  .accordian-btn-hbp:disabled {
    opacity: 0.5;
  }

  .accordian-btn:hover {
    background-color: ${({ theme }) => theme.palette.primaryBackground.color};
    color: ${({ theme }) => theme.palette.primaryButton.color};
    border: 1px solid ${({ theme }) => theme.palette.primaryButton.color};
    transform: translateY(-5px);
  }

  /* lens trial segment styles */
  .active-trial-segment {
    position: relative;
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem;
    padding: 1rem 1.25rem;
    height: 9rem;
    margin: ${({ theme }) => theme.sizing.marginXS}rem 0;
    border: 1px solid #d3dcef;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .active-content {
    background-color: #d3dcef;
  }

  .hilighted-overlay {
    background-color: rgb(211, 220, 239, 0.6);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    cursor: pointer;
  }

  .active-trial-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }

  .trial-best-value {
    position: absolute;
    top: 0;
    right: 0;
    font-size: ${({ theme }) => theme.sizing.fontXS}rem;
    font-family: ${({ theme }) => theme.typography.mainFontFamilyMedium};
    background: rgba(217, 149, 180, 0.23);
    width: 5rem;
    padding: 0.125rem 0.3rem;
    border-radius: 0 ${({ theme }) => theme.sizing.radiusXS}rem 0
      ${({ theme }) => theme.sizing.radiusXS}rem;
    z-index: 30;
  }

  .active-trial-segment p {
    margin: 0px;
    color: ${({ theme }) => theme.palette.primary.color};
  }

  .trial-text-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 30;
  }

  .trial-text-title-content {
    font-size: 0.75rem;
  }

  .trial-text-title-content p.trial-title {
    font-family: ${({ theme }) => theme.typography.mainFontFamilyMedium};
    white-space: nowrap;
  }

  .trial-text-title-content p.trial-description {
    font-family: ${({ theme }) => theme.typography.mainFontFamilyLight};
  }

  .trial-text-sub-content {
    font-size: 0.75rem;
    font-family: ${({ theme }) => theme.typography.mainFontFamilyMedium};
  }

  .trial-text-sub-content p {
    margin-bottom: 0.1rem;
  }

  .trial-text-sub-content span {
    text-decoration: line-through;
    text-decoration-thickness: 1.5px;
    text-decoration-color: #7590cc;
    color: #7590cc;
    font-family: ${({ theme }) => theme.typography.mainFontFamilyLight};
  }

  .trial-img {
    width: 6.25rem;
    margin-top: ${({ theme }) => theme.sizing.marginXS}rem;
    z-index: 30;

    &.esk-pdp-image {
      width: 7.95rem;
    }
  }

  .save-text-accordian-inactive {
    position: absolute;
    top: 18px;
    right: 0px;
    color: ${({ theme }) => theme.palette.primary.color};
    font-size: ${({ theme }) => theme.sizing.fontXS}rem;
    font-family: ${({ theme }) => theme.typography.mainFontFamilyMedium};
    background: rgba(217, 149, 180, 0.23);
    width: 6.5rem;
    padding: 0 0.3rem;
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem 0 0
      ${({ theme }) => theme.sizing.radiusXS}rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }

  .save-text-accordian-active {
    position: absolute;
    top: 15px;
    right: 0px;
    color: ${({ theme }) => theme.palette.primary.color};
    font-size: ${({ theme }) => theme.sizing.fontXS}rem;
    font-family: ${({ theme }) => theme.typography.mainFontFamilyMedium};
    background: rgba(217, 149, 180, 0.23);
    width: 6.5rem;
    padding: 0 0.3rem;
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem 0 0
      ${({ theme }) => theme.sizing.radiusXS}rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }

  .shipping-text-accordian {
    font-size: ${({ theme }) => theme.sizing.fontS}rem;
    font-style: italic;
    font-family: ${({ theme }) => theme.typography.mainFontFamilyLight};
  }

  /* single trial lens segment */
  .single-active-trial-segment {
    position: relative;
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem;
    padding: ${({ theme }) => theme.sizing.paddingXS}rem;
    height: 15rem;
    margin: ${({ theme }) => theme.sizing.marginXS}rem 0;
    border: 1px solid #d3dcef;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }

  .single-active-trial-content {
    text-align: left;
    width: 100%;
  }

  .single-trial-text-title-content {
    font-size: ${({ theme }) => theme.sizing.fontS}rem;
    margin-bottom: 0.2rem;
  }

  .single-trial-img {
    width: 10rem;
    margin: ${({ theme }) => theme.sizing.marginM}rem auto 0 auto;
  }

  .vitamin-styles {
    width: 9rem;
    margin: ${({ theme }) => theme.sizing.marginM}rem auto 0 auto;
  }

  /* otp segment styles */
  .active-otp-segment p {
    margin: 0px;
    color: ${({ theme }) => theme.palette.primary.color};
  }

  .active-otp-segment {
    border-radius: ${({ theme }) => theme.sizing.radiusXS}rem;
    padding: ${({ theme }) => theme.sizing.paddingXS}rem;
    height: 4.5rem;
    margin: 0.6rem 0;
    border: 1px solid #d3dcef;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
  }

  .otp-text-top {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 0.3rem;
  }

  .otp-text-top p {
    font-size: ${({ theme }) => theme.sizing.fontS}rem;
  }

  .otp-text-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .otp-text-bottom p {
    font-size: ${({ theme }) => theme.sizing.fontXS}rem;
  }

  .otp-text-bottom p:nth-child(2) {
    font-size: ${({ theme }) => theme.sizing.fontXS}rem;
  }
`;
